import { render, staticRenderFns } from "./PDFDocument.vue?vue&type=template&id=b6b9b39c&"
import script from "./PDFDocument.vue?vue&type=script&lang=js&"
export * from "./PDFDocument.vue?vue&type=script&lang=js&"
import style0 from "./PDFDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports